import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-iterate-image-large.tsx
/**
* icon.24.iterate.image.large
*
* Keywords: waveform, audio, sound, frequency, equalizer, vertical, bars, music
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTE4LjUgOWEuNS41IDAgMCAxIC41LjVWMTZhMyAzIDAgMCAxLTMgM0g2LjIwNmwxLjE0NyAxLjE0NmEuNS41IDAgMCAxLS43MDcuNzA3bC0yLTJhLjUuNSAwIDAgMSAwLS43MDdsMi0yYS41LjUgMCAwIDEgLjcwNy43MDdMNi4yMDYgMThIMTZhMiAyIDAgMCAwIDItMlY5LjVhLjUuNSAwIDAgMSAuNS0uNW0tOC43NzUgMi41ODJhLjUuNSAwIDAgMSAuNjI5LjA2NGwzLjUgMy41YS41LjUgMCAwIDEtLjcwNy43MDdMMTAgMTIuNzA4bC0xLjE0NiAxLjE0NmEuNS41IDAgMCAxLS43MDctLjcwN2wxLjUtMS41em02LjkyMi04LjQzNmEuNS41IDAgMCAxIC43MDcgMGwyIDJhLjUuNSAwIDAgMSAwIC43MDdsLTIgMmEuNS41IDAgMCAxLS43MDctLjcwN0wxNy43OTMgNkg4YTIgMiAwIDAgMC0yIDJ2Ni41YS41LjUgMCAwIDEtMSAwVjhhMyAzIDAgMCAxIDMtM2g5Ljc5M2wtMS4xNDYtMS4xNDdhLjUuNSAwIDAgMSAwLS43MDdNMTQgOGEyIDIgMCAxIDEgMCA0IDIgMiAwIDAgMSAwLTRtMCAxYTEgMSAwIDEgMCAwIDIgMSAxIDAgMCAwIDAtMiIvPjwvc3ZnPg==)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=25203-9829
*/
const Icon24IterateImageLarge = memo(function Icon24IterateImageLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M18.5 9a.5.5 0 0 1 .5.5V16a3 3 0 0 1-3 3H6.206l1.147 1.146a.5.5 0 0 1-.707.707l-2-2a.5.5 0 0 1 0-.707l2-2a.5.5 0 0 1 .707.707L6.206 18H16a2 2 0 0 0 2-2V9.5a.5.5 0 0 1 .5-.5m-8.775 2.582a.5.5 0 0 1 .629.064l3.5 3.5a.5.5 0 0 1-.707.707L10 12.708l-1.146 1.146a.5.5 0 0 1-.707-.707l1.5-1.5zm6.922-8.436a.5.5 0 0 1 .707 0l2 2a.5.5 0 0 1 0 .707l-2 2a.5.5 0 0 1-.707-.707L17.793 6H8a2 2 0 0 0-2 2v6.5a.5.5 0 0 1-1 0V8a3 3 0 0 1 3-3h9.793l-1.146-1.147a.5.5 0 0 1 0-.707M14 8a2 2 0 1 1 0 4 2 2 0 0 1 0-4m0 1a1 1 0 1 0 0 2 1 1 0 0 0 0-2"
		})
	});
});
//#endregion
export { Icon24IterateImageLarge };

//# sourceMappingURL=icon-24-iterate-image-large.js.map